<script>
	import StorageSettingsSubPage from "./StorageSettingsSubPage.svelte";
	import DeliverySettingsSubPage from "./DeliverySettingsSubPage.svelte";
</script>

<StorageSettingsSubPage/>
<DeliverySettingsSubPage/>
